// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"eca54368","488":"ac761506"}[chunkId] + ".chunk.js";
};